import React from 'react';
import { Timeframe, ALL_TIMEFRAMES } from '../types';

interface FilterBarProps {
  selectedTimeframe: Timeframe | 'all';
  onTimeframeChange: (value: Timeframe | 'all') => void;
  dateFrom: string;
  dateTo: string;
  onDateFromChange: (value: string) => void;
  onDateToChange: (value: string) => void;
}

function FilterBar({
  selectedTimeframe,
  onTimeframeChange,
  dateFrom,
  dateTo,
  onDateFromChange,
  onDateToChange,
}: FilterBarProps) {
  return (
    <div className="pq-filter-bar">
      <label className="pq-filter-label">Timeframe:</label>
      <select
        className="pq-filter-select"
        value={selectedTimeframe}
        onChange={(e) => onTimeframeChange(e.target.value as Timeframe | 'all')}
      >
        <option value="all">All</option>
        {ALL_TIMEFRAMES.map((tf) => (
          <option key={tf} value={tf}>
            {tf}
          </option>
        ))}
      </select>

      <label className="pq-filter-label">From:</label>
      <input
        type="date"
        className="pq-filter-date"
        value={dateFrom}
        onChange={(e) => onDateFromChange(e.target.value)}
      />

      <label className="pq-filter-label">To:</label>
      <input
        type="date"
        className="pq-filter-date"
        value={dateTo}
        onChange={(e) => onDateToChange(e.target.value)}
      />

      {(dateFrom || dateTo) && (
        <button
          className="pq-filter-clear"
          onClick={() => {
            onDateFromChange('');
            onDateToChange('');
          }}
        >
          Clear dates
        </button>
      )}
    </div>
  );
}

export default FilterBar;
